import {JsonEditor} from 'json-edit-react';
import { useCallback, useEffect, useState } from 'react';

const JsonViewer = ({ jsonData = {}, onChange, editable = true }) => {
  // console.log("🚀 ~ JsonViewer ~ jsonData:", jsonData)
  const [data, setData] = useState({});
  const [error, setError] = useState(null);

  // Initialize and update data when jsonData changes
  useEffect(() => {
    try {
      // Validate and parse jsonData if it's a string, or use it directly if it's an object
      const parsedData = typeof jsonData === 'string' ? JSON.parse(jsonData) : jsonData;
      if (parsedData && typeof parsedData === 'object') {
        setData(parsedData);
        setError(null);
      } else {
        throw new Error('Invalid JSON data provided');
      }
    } catch (err) {
      console.error('Error parsing JSON:', err);
      setError('Invalid JSON data. Please provide a valid JSON object.');
      setData({});
    }
  }, [jsonData]);

  // Handle JSON changes
 

  return (
    <>
     <JsonEditor
            data={data}
            rootName=''
            // onChange={handleChange}
            restrictEdit={editable} // Allow editing only if editable is true
            restrictDelete={true} // Allow deletion only if editable is true
            restrictAdd={true} // Allow adding only if editable is true
            indent={1} // Consistent indentation
            collapse={4}
            // collapse={false} // Collapse nested objects/arrays one level deep
            showLineNumbers // Improve usability for large JSON
            maxWidth={300} // Fit container
            stringTruncate={100}
            onError={(err) => {
              console.error('JsonEditor error:', err);
              setError('Error in JSON editor: ' + err.message);
            }}
            onUpdate={ ({ newData }) => {
     
      if (onChange) {
          onChange(newData); // Call parent callback with the new JSON
        }
    }}
          />
    </>
  );
};

export default JsonViewer